import { CrudForm } from '../shared/CrudPage';
import { menuService } from '@kss/api';
import type { Menu, MenuCreate, MenuFilter } from '@kss/api';
import { loadMenuOptions } from '../shared/formLoaders';

type F = { name: string; icon: string; path: string; parentId: string; sortOrder: number; isActive: boolean };
const empty: F = { name: '', icon: '', path: '', parentId: '', sortOrder: 0, isActive: true };

export default function NewMenu() {
  return (
    <CrudForm<Menu, MenuCreate, MenuFilter, F>
      title="menu" service={menuService} idKey="menuId" basePath="/panel/menus" emptyForm={empty}
      fields={[
        { key: 'name', label: 'Name', required: true, placeholder: 'Dashboard' },
        { key: 'icon', label: 'Icon', placeholder: 'LayoutDashboard' },
        { key: 'path', label: 'Path', placeholder: '/panel/dashboard' },
        { key: 'parentId', label: 'Parent menu', type: 'search', loadOptions: loadMenuOptions, placeholder: 'Pick parent (optional)' },
        { key: 'sortOrder', label: 'Sort order', type: 'number' },
        { key: 'isActive', label: 'Active', type: 'status' },
      ]}
      fromEntity={(r) => ({
        name: r.name ?? '', icon: r.icon ?? '', path: r.path ?? '',
        parentId: r.parentId == null ? '' : String(r.parentId), sortOrder: Number(r.sortOrder ?? 0), isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        menuId: id, name: f.name, icon: f.icon || undefined, path: f.path || undefined,
        parentId: f.parentId || undefined, sortOrder: f.sortOrder || undefined, isActive: f.isActive,
      })}
      validate={(f) => !f.name.trim() ? 'Name is required' : null}
    />
  );
}
